import React, { useEffect, useState } from 'react'
import AppHeader from '../../components/AppHeader'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import OTPLoginPage from '../../components/OTPLoginPage';
import CustomerCheckinForm from '../../components/checkin/CustomerCheckinForm';
import moment from 'moment';

import { Step, StepLabel, Stepper } from '@mui/material';
import CheckinBackButton from '../CheckinBackButton';
import portalServices from '../../portalServices';
import { useAlert } from '../../../../context/AlertContext';



const Step3 = ({queue,service,selectedDate,selectedTime}) =>{
  return (
    <div className='col-md-12 mt-3 mb-5'>
      <Stepper activeStep={2}>
        <Step>
          <StepLabel>{queue.title}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{service.title} on {moment(selectedDate).format("LL")} at {selectedTime.displayTime}</StepLabel>
        </Step>
        <Step>
          <StepLabel>Book Token</StepLabel>
        </Step>
      </Stepper>
    </div>
  )
}

function SlotCheckinFormPage() {

  const {queueId,serviceId} = useParams();
  const [customerToken,setCustomerToken] =  useState(localStorage.customerToken);
  const navigate = useNavigate();
  const location = useLocation();

  const {AppAlert} = useAlert();
  
  const [savingInprogress,setSavingStatus] = useState(false);
  const [customerList,setCustomerList] = useState(null);


  const {queue,service,selectedDate,selectedTime} = location.state?location.state:{queue:null,service:null,selectedDate:null};

  const getCustomerList = () => {
    let payload = {
      customerToken:customerToken
    }
    portalServices.getCustomerProfileList(payload).then(res=>{
      setCustomerList(res.data);
    }).catch(error=>{

    })
  }

  useEffect(()=>{
    if(customerToken){
      getCustomerList();
    }
  },[customerToken])

  useEffect(()=>{
    if(queue===null ){
      navigate("/schedule-checkin/queue")
    }
  },[])

  const doSlotCheckinWithCustomerId = (customerId) =>{
    let payload = {
        "queueId":queue.id,
        "serviceId":service.id,
        "customerId":customerId,
        selectedDate:moment(selectedDate).format("YYYY-MM-DD"),
        selectedTime:selectedTime.time
    }
    setSavingStatus(true)
    portalServices.doSlotCheckinWithCustomerId(payload).then(res=>{
        //publishMessage({event:"new_token",token:null})
        navigate("/token-details");
    }).catch(error=>{
        AppAlert(error.msg)
    }).finally(()=>{
        setSavingStatus(false)
    })  
  }

  return (
    <>
        
        <AppHeader/>
        {queue && service &&
          <div className='container'>
            <CheckinBackButton/>
            <Step3 queue={queue} service={service} selectedDate={selectedDate} selectedTime={selectedTime} />
            {
              (customerToken === null || customerToken === undefined)?
                <OTPLoginPage
                  setCustomerToken={setCustomerToken}
                /> 
              :
              <>
              {customerList !== null && customerList.length > 0 &&
                  <div>
                    {customerList.map(customerDetails=>
                      <div className='card my-2' key={customerDetails.id} >
                        <div className='card-body'>
                          <button className='btn btn-primary' onClick={()=>doSlotCheckinWithCustomerId(customerDetails.id)} >Book Token for {customerDetails.firstName}</button>
                        </div>
                      </div>
                    )}
                    <div className='card' >
                        <div className='card-body'>
                          <button className='btn btn-outline-primary' onClick={()=>setCustomerList([])}>Or Create New Profile</button>
                        </div>
                      </div>
                  </div>
                }
                {customerList !== null && customerList.length === 0 &&
                  <CustomerCheckinForm
                    queueId={queue.id}
                    serviceId={service.id}
                    customerToken={customerToken}
                    selectedDate={moment(selectedDate).format("YYYY-MM-DD")}
                    selectedTime={selectedTime.time}
                  />
                }
              </>
            }
          </div>
        }
    </>
  )
}

export default SlotCheckinFormPage